import React, { FC } from "react";

export type VideoListRefactorIconName =
  | "search"
  | "upload"
  | "check-square"
  | "check-circle"
  | "plus-circle"
  | "languages"
  | "download"
  | "trash-2"
  | "edit-2"
  | "play"
  | "pause"
  | "pin"
  | "chevron-left"
  | "chevron-right"
  | "refresh-cw"
  | "send"
  | "rotate-ccw"
  | "undo";

interface Props {
  name: VideoListRefactorIconName;
  size?: number;
  className?: string;
}

/**
 * 与 doc/4.视频列表页.html 中 data-lucide 图标保持同风格描边。
 */
export const VideoListRefactorLucideIcon: FC<Props> = ({ name, size = 14, className }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    className,
    "aria-hidden": true,
  };

  if (name === "search") {
    return (
      <svg {...common}>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
    );
  }
  if (name === "upload") {
    return (
      <svg {...common}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
    );
  }
  if (name === "check-square") {
    return (
      <svg {...common}>
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    );
  }
  if (name === "check-circle") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    );
  }
  if (name === "plus-circle") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="16" />
        <line x1="8" y1="12" x2="16" y2="12" />
      </svg>
    );
  }
  if (name === "languages") {
    return (
      <svg {...common}>
        <path d="m5 8 6 6" />
        <path d="m4 14 6-6 2-3" />
        <path d="M2 5h12" />
        <path d="M7 2h1" />
        <path d="m22 22-5-10-5 10" />
        <path d="M14 18h6" />
      </svg>
    );
  }
  if (name === "download") {
    return (
      <svg {...common}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
    );
  }
  if (name === "trash-2") {
    return (
      <svg {...common}>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      </svg>
    );
  }
  if (name === "edit-2") {
    return (
      <svg {...common}>
        <path d="M17 3a2.83 2.83 0 1 1 4 4L7 21l-4 1 1-4Z" />
      </svg>
    );
  }
  if (name === "play") {
    return (
      <svg {...common}>
        <polygon points="5 3 19 12 5 21 5 3" />
      </svg>
    );
  }
  if (name === "pause") {
    return (
      <svg {...common}>
        <rect x="6" y="4" width="4" height="16" rx="1" />
        <rect x="14" y="4" width="4" height="16" rx="1" />
      </svg>
    );
  }
  if (name === "pin") {
    return (
      <svg {...common}>
        <line x1="12" y1="17" x2="12" y2="22" />
        <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.79-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.79.9A2 2 0 0 0 5 15.24Z" />
      </svg>
    );
  }
  if (name === "chevron-left") {
    return (
      <svg {...common}>
        <polyline points="15 18 9 12 15 6" />
      </svg>
    );
  }
  if (name === "refresh-cw") {
    return (
      <svg {...common}>
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 3" />
        <path d="M21 3v5h-5" />
        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 21" />
        <path d="M3 21v-5h5" />
      </svg>
    );
  }
  if (name === "send") {
    return (
      <svg {...common}>
        <path d="m22 2-7 20-4-9-9-4Z" />
        <path d="M22 2 11 13" />
      </svg>
    );
  }
  if (name === "rotate-ccw") {
    return (
      <svg {...common}>
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
      </svg>
    );
  }
  if (name === "undo") {
    return (
      <svg {...common}>
        <path d="M9 14 4 9l5-5" />
        <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
};
